
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {Comment} from '../comment/comment';
import { NC } from './nc';

@Injectable({ providedIn: 'root' })
export class CommentService
{
constructor(private http: HttpClient) { 
     
    }
      ticketviewurl = environment.graphURL;
      ticketsurl = environment.appURL+"/tickets";
    commenturl = environment.appURL+"/comments";


    createNewComment (comment: NC): Observable<any> {
    let upd = JSON.stringify(comment);
    return this.http.post<Comment>(this.commenturl + "/" , 
    upd , 
    {headers: new HttpHeaders({"Authorization":"Bearer " + environment.token, "Content-Type": "application/json"})})
   .pipe(
     tap(_ => {}),
     catchError(this.handleError<Comment>('updateStatus'))
   );
 }
 

 updateComment (comment: NC): Observable<any> {
  
  let upd = JSON.stringify(comment);
    return this.http.put<Comment>(this.commenturl + "/"+ comment.id , upd , {headers: new HttpHeaders({"Authorization":"Bearer " + environment.token, "Content-Type": "application/json"})})
   .pipe(
     tap(_ => {}),
     catchError(this.handleError<Comment>('updateStatus'))
   );
 }

 deleteComment(comment: Comment, jwt : string): Observable<any> {

  let options = {
    headers: new HttpHeaders(
      {"Authorization":"Bearer " + jwt, "Content-Type": "application/x-www-form-urlencoded"
    }),
    body: comment,
  };
 const urld = this.commenturl + "/" + comment.id; 
  
 return this.http.delete<Comment>(urld , options);
}

private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
